// @ts-nocheck
import createWeeklyTimetableWidget from './createWeeklyTimetableWidget';

export default ({ editorAPI }) =>
  createWeeklyTimetableWidget({
    editorAPI,
  });
